import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import actions from '../../../../actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BranchOverridePage from '../../../presenters/admins/BranchOverridePage/BranchOverridePage';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import { DEFAULT_ACTIVE_BRANCH_ID } from '../../../../constants/constants';

const PAGINATION_SIZE = [5, 10, 20, 50];
const DEFAULT_PAGE_SIZE = 50;
const ADD_ACTION = 1;
const REMOVE_ACTION = 2;

class BranchOverrideContainer extends PureComponent {
  constructor(props) {
    super(props);

    const branchCode =
      DEFAULT_ACTIVE_BRANCH_ID !== this.props.appStore.activeBranchId
        ? this.props.appStore.branches.find(
            (branch) => branch.branchId === this.props.appStore.activeBranchId
          ).branchName
        : null;

    const actions = [
      { value: ADD_ACTION, displayName: 'action.add' },
      { value: REMOVE_ACTION, displayName: 'action.remove' }
    ];

    const approvalTiers = [
      { value: 1, displayName: 'tier1_approval' },
      { value: 2, displayName: 'tier2_approval' },
      { value: 3, displayName: 'tier3_approval' }
    ];

    this.state = {
      employees: [],
      employeeId: '',
      branchCode,
      branchId: this.props.appStore.activeBranchId,
      loading: false,
      page: {
        size: DEFAULT_PAGE_SIZE,
        number: 0
      },
      sortBy: {
        name: 'branchCode',
        direction: 'asc'
      },
      actions,
      approvalTiers,
      selectedApprovalTier: approvalTiers[0].value,
      selectedAction: actions[0].value
    };

    this.loadState = this.loadState.bind(this);
    this.getSearchCriteria = this.getSearchCriteria.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.onEmployeeIdChange = this.onEmployeeIdChange.bind(this);
    this.onChangeApprovalTier = this.onChangeApprovalTier.bind(this);
    this.onChangeAction = this.onChangeAction.bind(this);
    this.onAction = this.onAction.bind(this);
  }

  componentDidMount() {
    this.loadState();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.appStore.activeBranchId !== this.props.appStore.activeBranchId
    ) {
      const branchCode =
        DEFAULT_ACTIVE_BRANCH_ID !== this.props.appStore.activeBranchId
          ? this.props.appStore.branches.find(
              (branch) => branch.branchId === this.props.appStore.activeBranchId
            ).branchName
          : null;

      this.setState({
        branchCode,
        branchId: this.props.appStore.activeBranchId
      });
      this.loadState();
    }
  }

  loadState() {
    this.setState(
      {
        loading: true
      },
      () => {
        api.imitableEmployees
          .search(this.getSearchCriteria(), {
            page: this.state.page,
            sortBy: this.state.sortBy
          })
          .then((response) => {
            const employess = response.data.content;
            employess.forEach((employee) => {
              const matchingBranch = this.props.appStore.branches.find(
                (branch) => branch.branchId === employee.branchId
              );
              employee.branchDescription = !!matchingBranch
                ? matchingBranch.branchDesc
                : null;
            });

            this.setState({
              employees: response.data.content,
              loading: false,
              page: {
                size: response.data.size,
                totalElements: response.data.totalElements,
                number: response.data.number,
                numberOfElements: response.data.numberOfElements
              }
            });
          })
          .catch((err) => {
            console.error('error fetching employees: ', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  onEmployeeIdChange(value) {
    this.setState({
      employeeId: value
    });
  }

  onChangeApprovalTier(value) {
    this.setState({
      selectedApprovalTier: value
    });
  }

  onChangeAction(value) {
    this.setState({
      selectedAction: value
    });
  }

  getSearchCriteria() {
    const branchIds =
      DEFAULT_ACTIVE_BRANCH_ID !== this.props.appStore.activeBranchId
        ? [
            this.props.appStore.branches.find(
              (branch) => branch.branchId === this.props.appStore.activeBranchId
            ).branchId
          ]
        : this.props.appStore.branches.map((branch) => branch.branchId);

    return {
      branchIds,
      overridesOnly: true
    };
  }

  getActionCriteria() {
    return {
      branchId: this.state.branchId,
      branchCode: this.state.branchCode,
      employeeId: this.state.employeeId,
      approvalTier:
        this.state.selectedAction === ADD_ACTION
          ? this.state.selectedApprovalTier
          : null,
      validUntil: this.state.selectedAction === ADD_ACTION ? '2099-01-01' : null
    };
  }

  handleChangeRowsPerPage(rows) {
    this.setState(
      {
        page: {
          size: rows,
          numberOfElements: rows,
          totalElements: this.state.page.totalElements,
          number: 0
        }
      },
      this.loadState
    );
  }

  handleChangePage(number) {
    this.setState(
      {
        page: {
          ...this.state.page,
          number
        }
      },
      this.loadState
    );
  }

  onAction() {
    const apiEndpoint =
      this.state.selectedAction === ADD_ACTION
        ? api.imitableEmployees.addBranchOverride
        : api.imitableEmployees.removeBranchOverride;

    this.setState(
      {
        loading: true
      },
      () => {
        apiEndpoint(this.getActionCriteria())
          .then((response) => {
            this.setState(
              {
                employeeId: ''
              },
              this.loadState
            );
          })
          .catch((err) => {
            console.error('error performing action', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <BranchOverridePage
        employees={this.state.employees}
        employeeId={this.state.employeeId}
        page={this.state.page}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        handleChangePage={this.handleChangePage}
        rowsPerPageOptions={PAGINATION_SIZE}
        branchCode={this.state.branchCode}
        branchId={this.state.branchId}
        actions={this.state.actions}
        approvalTiers={this.state.approvalTiers}
        selectedApprovalTier={this.state.selectedApprovalTier}
        selectedAction={this.state.selectedAction}
        onEmployeeIdChange={this.onEmployeeIdChange}
        onChangeAction={this.onChangeAction}
        onChangeApprovalTier={this.onChangeApprovalTier}
        onAction={this.onAction}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchOverrideContainer)
);
